import { parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * Formats a raw phone number for display:
 * - 10 digits      → (209) 964‑1387
 * - 11–15 digits   → +1 (209) 964‑1387
 * 
 * @param {string} raw - The raw phone number string to format
 * @param {string} defaultCountry - Optional default country code to use if no international prefix
 * @returns {string} The formatted phone number for display
 */
export function formatPhoneNumberForDisplay(raw, defaultCountry = 'US') {
    if (!raw) return '';
    
    // Clean the input - keep only digits
    const digits = raw.replace(/\D/g, '');
    
    try {
      let phone;
      
      if (digits.length === 10) {
        phone = parsePhoneNumberFromString(digits, defaultCountry);
        return phone ? phone.formatNational() : raw;
      }
      
      else if (digits.length > 10 && digits.length <= 15) {
        // Add + prefix to help the parser identify country code
        phone = parsePhoneNumberFromString(`+${digits}`);
        
        if (phone && phone.isValid()) {
          return `+${phone.countryCallingCode} ${phone.formatNational()}`;
        }
      }
      
      // Fallback to original if parsing failed or invalid
      return raw;
      
    } catch (error) {
      console.error('Error formatting phone number:', error);
      return raw;
    }
  }